import React, { FC } from 'react';

interface Props {
  title?: string;
  subTitle?: string;
  className?: string;
  classes?: {
    childDivClass?: string;
    pClass?: string;
  };
  style?: React.CSSProperties;
}

const MainHCell: FC<Props> = ({ title }) => {
  return (
    <div className='flex flex-col gap-1 items-center py-6 bg-dropDownMenuBg border-b border-white/60 justify-center'>
      <p className='xl:text-lg text-base text-white font-semibold text-center'>
        {title === 'Affiliate' ? 'Prime' : title}
      </p>
    </div>
  );
};

export default MainHCell;
